import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import { Input } from 'src/@/components/ui/input';
import v2_actionCriarEstagioFunil from 'src/actions/v2/cliente/v2_actionCriarEstagioFunil';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function PopoverCriarEstagio({
  user,
  cliente,
  open,
  pipelineId,
  onClose,
  onCallback,
}) {
  const { t } = useTranslation('settings');
  const [nome, setNome] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleCriarEstagioFunil() {
    try {
      setLoading(true);
      const result = await v2_actionCriarEstagioFunil(cliente._id, {
        scope: {
          nome,
          pipeline_id: pipelineId,
          criado_por: user.id,
          cliente_id: cliente._id,
        },
      });
      if (result.status === 200) {
        onCallback();
        setNome('');
        onClose();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Popover open={open} onOpenChange={onClose}>
      <PopoverTrigger asChild>
        <div />
      </PopoverTrigger>
      <PopoverContent className="w-80 p-5 border border-[#e7e7ec] rounded-[12px] shadow-none" style={{ fontFamily: D.fontStack }}>
        <div className="flex flex-col gap-4">
          <div className={D.field}>
            <label className={D.label}>{t('funnel.core.stagePopover.nameLabel', 'Nome do estágio')}</label>
            <Input
              value={nome}
              placeholder={t('funnel.core.stagePopover.namePlaceholder', 'Nome estágio')}
              onChange={(event) => setNome(event.target.value)}
              className={D.input}
            />
            <p className={D.hint}>
              {t('funnel.core.stagePopover.nameHint', 'Ex.: Qualificação, Proposta, Fechamento.')}
            </p>
          </div>
          <button
            type="button"
            onClick={handleCriarEstagioFunil}
            disabled={loading || !nome.trim()}
            className={D.primaryButton}
          >
            {loading
              ? t('funnel.core.stagePopover.savingButton', 'Salvando...')
              : t('buttons.save', { ns: 'common' })}
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
